import React, { useRef, useState } from 'react'
import styled from 'styled-components'
import { Col, Container, Row } from 'react-bootstrap'
import { Box, InnerHeading, LazyImage, MainHeading, SpanStyled, SpanStyledB, TextStyled } from '../../../ui/Elements'
import { Check, Contact1, Contact2, FormBg, FormBgEn } from '../../../ui/AllImages'
import ContactForm from './ContactForm'
import Map from './Map'
import { useTranslation } from 'react-i18next'
import StepOne from './Step1'
import StepTwo from './Step2'
import StepThree from './Step3'
import StepFour from './Step4'
import StepFive from './Step5'
import MapSearchSelect from '../../map/mapInput'
const Contact = () => {
    const { t } = useTranslation();
    const [currentStep, setCurrentStep] = useState(1);
    const [formData, setFormData] = useState({});
    const formRef = useRef(null);
    const nextStep = () => {
        setCurrentStep(currentStep + 1);
        scrollToTop();
    };
    const prevStep = () => {
        setCurrentStep(currentStep - 1);
        scrollToTop();
    };
    const scrollToTop = () => {
        if (formRef.current) {
            const yOffset = -80;
            const y = formRef.current.getBoundingClientRect().top + window.scrollY + yOffset;
            window.scrollTo({ top: y, behavior: "smooth" });
        }
    };
    return (
        <ContactWrapper className='container-fluid common-space contactFluid' id='contact'  ref={formRef}>
            <Container>
                <Box className='contactContainer'>
                    <Row className='contactRow'>
                        <Col md={12} lg={7}>
                            <Box className='contactFormContainer'>
                                <Box className='d-flex flex-column align-items-start justify-content-start contactHeading contactHeadingMain mb-2'>
                                    <InnerHeading className='' lh="1.2">{t('ContactusHeading')}</InnerHeading>
                                </Box>
                                {currentStep  === 1 && <StepOne nextStep={nextStep}  formData={formData} setFormData={setFormData}/>}
                                {currentStep  === 2 && <StepTwo nextStep={nextStep} prevStep={prevStep} formData={formData} setFormData={setFormData} />}
                                {currentStep  === 3 && <StepThree nextStep={nextStep} prevStep={prevStep} formData={formData} setFormData={setFormData} />}
                                {currentStep  === 4 && <StepFour nextStep={nextStep} prevStep={prevStep} formData={formData} setFormData={setFormData} />}
                                {currentStep  === 5 && <StepFive setStep={setCurrentStep}  prevStep={prevStep} formData={formData} setFormData={setFormData} />}
                            </Box>
                        </Col>
                        <Col md={12} lg={5} className='contactSecCol'>
                            <Box className=''>
                                <Box className='d-flex flex-column align-items-start justify-content-start contactHeading'>
                                    <InnerHeading className='' lh="1.2" size="22px" color="var(--themeColor)">{t('Movingtonew')}</InnerHeading>
                                </Box>
                                <Box className='d-flex flex-column align-items-start justify-content-start contactHeading contactHeadingMain'>
                                    <InnerHeading className='' lh="1.2" size="35px" color="var(--secondaryColor)">{t('Letusmakeit')}</InnerHeading>
                                </Box>
                            </Box>
                            <Box className="ctPointsList">
                                <ul>
                                    <li>
                                        <Box className='checkList'>
                                            <Check />
                                        </Box>
                                        <Box className='listContent'>
                                            <SpanStyledB >
                                                {t('Nomoreworries')}
                                            </SpanStyledB>
                                            <SpanStyled >
                                                {t('Wehandleeverything')}
                                            </SpanStyled>
                                        </Box>
                                    </li>
                                    <li>
                                        <Box className='checkList'>
                                            <Check />
                                        </Box>
                                        <Box className='listContent'>
                                            <SpanStyledB >
                                                {t('Savetimeeffort')}
                                            </SpanStyledB>
                                            <SpanStyled >
                                                {t('Ourexpertsensure')}
                                            </SpanStyled>
                                        </Box>
                                    </li>
                                    <li>
                                        <Box className='checkList'>
                                            <Check />
                                        </Box>
                                        <Box className='listContent'>
                                            <SpanStyledB >
                                                {t('Peaceofmind')}
                                            </SpanStyledB>
                                            <SpanStyled >
                                                {t('Yourfurniturevaluables')}
                                            </SpanStyled>
                                        </Box>
                                    </li>
                                    <li>
                                        <Box className='checkList'>
                                            <Check />
                                        </Box>
                                        <Box className='listContent'>
                                            <SpanStyledB >
                                                {t('Settleinquickly')}
                                            </SpanStyledB>
                                            <SpanStyled >
                                                {t('Movewithstartenjoying')}
                                            </SpanStyled>
                                        </Box>
                                    </li>
                                </ul>
                            </Box>
                        </Col>
                    </Row>
                </Box>
            </Container>
        </ContactWrapper>
    )
}
const ContactWrapper = styled.section`
    margin-top: -40px;
    padding-bottom: 100px;
    background-image: url(${FormBgEn});
    background-repeat: no-repeat;
    background-position: right 0 bottom 0;
    position: relative;
    z-index: 40;
    .contactSecCol{
        padding-left: 30px;
        padding-top: 110px;
    }
    .contactFormContainer{
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
        width: 100%;
        height: 100%;
        background-color: var(--white);
        background: var(--gradientBg);
        border-radius: 10px;
        padding: 40px;
        box-shadow: 3px 23px 70px rgba(0, 0, 0, 0.13);
        -webkit-box-shadow: 3px 23px 70px rgba(0, 0, 0, 0.13);
        -moz-box-shadow: 3px 23px 70px rgba(0, 0, 0, 0.13);
    }
    .ctPointsList{
        display: block;
        width: 100%;
        padding: 0;
        ul{
            display: block;
        width: 100%;
        padding: 0;
        li{
            display: flex;
        width: 100%;
        padding: 0;
        gap: 14px;
        align-items: flex-start;
        margin-top: 25px;
        span{
            width: 100%;
        }
        .listContent{
            display: flex;
        width: 100%;
        flex-wrap: wrap;
        }
        .checkList{
            min-width: 20px;
            max-width: 20px;
        }
        }
        }
    }
    body.rtl & {
        background-image: url(${FormBg});
        background-repeat: no-repeat;
        background-position: left 0 bottom 0;
        .contactSecCol{
            padding-left: calc(var(--bs-gutter-x) * .5);
            padding-right: 30px;
            padding-top: 110px;
        }
        .contactFormContainer{
            background: var(--gradientBgAr);
        }
    }
    @media (max-width: 991px) {
        margin-top: -30px;
        padding-top: 0;
        padding-left: 0;
        padding-right: 0;
        padding-bottom: 60px;
        .contactSecCol {
            padding-top: 40px !important;
            padding-left: calc(var(--bs-gutter-x) * .5) !important;
            padding-right: calc(var(--bs-gutter-x) * .5) !important;
        }
        .contactFormContainer{
            padding: 25px 15px 30px 15px;
        }
        .contactHeadingMain > div{
            font-size: 25px;
        }
    }
`
export default Contact
